// A wrapper for <Route> that redirects to the login


import React, { ReactNode, type JSX } from "react";
import { Box } from "@mui/material";
import ProgressIndicator from "../progress-indicator/ProgressIndicator";


export type ContentViewProps = { 
  children?: ReactNode;
}

export function ContentView({children }: ContentViewProps): JSX.Element {
    
    return (
        //   <Route
        //     {...rest}
        //     render={({ location }) =>
        //       authenticated ? (
        //         children
        //       ) : (
        //         <Redirect
        //           to={{
        //             pathname: "/login",
        //             state: { from: location }
        //           }}
        //         />
        //       )
        //     }
        //   />
        (<Box sx={{
            display: "flex",
            flexDirection: "column",
            //flex: '1 1 auto',
            flex: '1 1 100%',
            overflow: "hidden",
            minHeight: 0, // fix for flex child overflow issue
        }}>
            <ProgressIndicator showTemporary={false} />
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                flex: '1 1 auto',
                overflow: "hidden",
                height: "100%",
                position: 'relative',
                minHeight: 0, // fix for flex child overflow issue
            }}>
                { children }
            </Box>
        </Box>)
    );
}
